import axios from 'axios';
import qs from "qs";

const setNewUser = ({url,data}) => axios.post(`${url}/index.php?r=coursePeopleTeam/addPerson`, qs.stringify({User: data}));

export default {
    setNewUser
};
